/**
 * This tab's realtime origin — a random id made once per page load.
 *
 * Every request carries it (`X-Realtime-Origin`, see request-headers.ts); the
 * platform stamps it on the realtime events a write causes. The tab's realtime
 * subscriber compares an event's origin with this value to recognise the echo
 * of its own write, which its mutation's `onSuccess` already refreshed.
 *
 * Not a secret and not an identity: a fresh value per tab, never stored.
 */
function createRealtimeOrigin(): string {
  const random =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`;
  return `tab-${random}`;
}

export const REALTIME_ORIGIN: string = createRealtimeOrigin();
